import script from "./SearchText.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchText.vue?vue&type=script&setup=true&lang=ts"

import "./SearchText.vue?vue&type=style&index=0&id=4ac0f306&scoped=true&lang=css"
import "./SearchText.vue?vue&type=style&index=1&id=4ac0f306&lang=css"

import exportComponent from "../../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ac0f306"]])

export default __exports__